<div class="graphic-area">
    <p style="text-align: center;">Dados do recebimento</p>
    <div id="chart_div"></div>
</div>